import React, { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import FieldError from './FieldError';

const SwitchField = ({
    name,
    className,
    onChange,
    label,
    info,
    registerOptions = {}
}) => {
    const { register, errors, watch } = useFormContext();

    // Watch the form value
    const formValue = watch(name);

    // State to manage checked status for styling
    const [checked, setChecked] = useState(false);
    const [initialized, setInitialized] = useState(false);

    // Update local state only on initial load when form value becomes available
    useEffect(() => {
        if (!initialized && formValue !== undefined) {
            setChecked(Boolean(formValue));
            setInitialized(true);
        }
    }, [formValue, initialized]);

    // Inline styles to replace external SCSS classes
    const styles = {
        switchField: {
            marginBottom: '1rem',
        },
        label: {
            display: 'block',
            fontWeight: 'bold',
            marginBottom: '0.5rem',
        },
        flex: {
            display: 'flex',
            alignItems: 'center',
        },
        marginRightSmall: {
            marginRight: '0.5rem',
        },
        marginLeftSmall: {
            marginLeft: '0.5rem',
        },
        marginSmall: {
            margin: '0 0.5rem',
        },
        switch: {
            position: 'relative',
            display: 'inline-block',
            width: '40px',
            height: '24px',
        },
        switchInput: {
            opacity: 0,
            width: 0,
            height: 0,
        },
        switchLabel: {
            position: 'absolute',
            cursor: 'pointer',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: '#ccc',
            borderRadius: '24px',
            transition: '.4s',
        },
        switchLabelChecked: {
            backgroundColor: '#4caf50',
        },
        switchLabelBefore: {
            content: '""',
            position: 'absolute',
            left: '4px',
            top: '4px',
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            background: '#fff',
            transition: '.4s',
        },
        help: {
            color: '#48c774',
            fontSize: '1.1rem',
            marginTop: '0.25rem',
        }
    };

    const handleChange = (e) => {
        setChecked(e.target.checked);
        if (onChange) onChange(e);
    };

    return (
        <div style={styles.switchField} className={className}>
            <label style={styles.label}>{label}</label>
            <div style={styles.flex}>
                <div style={{ ...styles.switch, ...styles.marginSmall }}>
                    <input
                        id={`${name}_switch`}
                        name={name}
                        type="checkbox"
                        onChange={handleChange}
                        ref={register(registerOptions)}
                        style={styles.switchInput}
                        checked={checked}
                    />
                    <label
                        htmlFor={`${name}_switch`}
                        style={{
                            ...styles.switchLabel,
                            ...(checked ? styles.switchLabelChecked : {}),
                        }}
                    >
                        <span
                            style={{
                                ...styles.switchLabelBefore,
                                transform: checked ? 'translateX(4px)' : 'translateX(0)',
                                position: 'absolute',
                                left: checked ? '16px' : '4px',
                                top: '4px',
                                width: '16px',
                                height: '16px',
                                borderRadius: '50%',
                                background: '#fff',
                                transition: '.4s',
                                display: 'block',
                            }}
                        />
                    </label>
                </div>
            </div>
            {info && <p style={styles.help}>{info}</p>}
            <FieldError errors={errors[name]} />
        </div>
    )
}

export default SwitchField
